// ---------- Announcement bar rotation ----------
function initAnnouncementBar(){
  const el = document.getElementById("announce-text");
  if(!el) return;
  const messages = [
    "🚚 Cash on Delivery Available Across Pakistan",
    "📦 Fast Nationwide Delivery",
    "💬 WhatsApp Support Available",
  ];
  let idx = 0;
  setInterval(()=>{
    el.classList.add("flip");
    setTimeout(()=>{
      idx = (idx+1) % messages.length;
      el.textContent = messages[idx];
    }, 300);
    setTimeout(()=> el.classList.remove("flip"), 600);
  }, 3800);
}

// ---------- Mobile nav ----------
function initMobileNav(){
  const btn = document.getElementById("mobile-toggle");
  const nav = document.getElementById("main-nav");
  if(!btn || !nav) return;
  btn.addEventListener("click", ()=>{
    const open = nav.classList.toggle("open");
    btn.setAttribute("aria-expanded", open ? "true" : "false");
  });
}

// ---------- Header search toggle ----------
function initHeaderSearch(){
  const btn = document.getElementById("search-toggle");
  const panel = document.getElementById("header-search");
  if(!btn || !panel) return;
  btn.addEventListener("click", ()=>{
    const isHidden = panel.hasAttribute("hidden");
    if(isHidden){
      panel.removeAttribute("hidden");
      btn.setAttribute("aria-expanded", "true");
      const input = panel.querySelector("input[type=search]");
      if(input) input.focus();
    } else {
      panel.setAttribute("hidden", "");
      btn.setAttribute("aria-expanded", "false");
    }
  });
}

// ---------- Quantity steppers (product page, cart page) ----------
function initQtySteppers(){
  document.querySelectorAll("[data-qty-step]").forEach(btn=>{
    btn.addEventListener("click", ()=>{
      const wrap = btn.closest("[data-qty-wrap]");
      const input = wrap.querySelector("input[type=number], input[name='quantity'], input[name='updates[]']");
      if(!input) return;
      const step = parseInt(btn.getAttribute("data-qty-step"), 10);
      const next = Math.max(1, (parseInt(input.value,10) || 1) + step);
      input.value = next;
      if(wrap.hasAttribute("data-auto-submit")){
        wrap.closest("form").submit();
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", ()=>{
  initAnnouncementBar();
  initMobileNav();
  initHeaderSearch();
  initQtySteppers();
});
